import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full z-50 bg-white shadow-lg">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-gray-800 hover:text-blue-600 transition duration-300">Olimars</Link>
        <nav className="hidden md:flex items-center space-x-6">
          <ul className="flex space-x-6">
            <li><Link to="/" className="text-gray-600 hover:text-blue-600 hover:underline transition duration-300">Início</Link></li>
            <li><Link to="/produtos" className="text-gray-600 hover:text-blue-600 hover:underline transition duration-300">Produtos</Link></li>
            <li><Link to="/sobre" className="text-gray-600 hover:text-blue-600 hover:underline transition duration-300">Sobre</Link></li>
            <li><Link to="/faq" className="text-gray-600 hover:text-blue-600 hover:underline transition duration-300">FAQ</Link></li>
            <li><Link to="/contacto" className="text-gray-600 hover:text-blue-600 hover:underline transition duration-300">Contacto</Link></li>
          </ul>
          <Link to="/contacto" className="bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition duration-300">
            Contacto
          </Link>
        </nav>
        <button
          className="md:hidden text-gray-600 focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>
      </div>
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <ul className="flex flex-col space-y-2 px-4 py-4">
            <li><Link to="/" className="block text-gray-600 hover:text-blue-600 hover:underline transition duration-300" onClick={() => setIsOpen(false)}>Início</Link></li>
            <li><Link to="/produtos" className="block text-gray-600 hover:text-blue-600 hover:underline transition duration-300" onClick={() => setIsOpen(false)}>Produtos</Link></li>
            <li><Link to="/sobre" className="block text-gray-600 hover:text-blue-600 hover:underline transition duration-300" onClick={() => setIsOpen(false)}>Sobre</Link></li>
            <li><Link to="/faq" className="block text-gray-600 hover:text-blue-600 hover:underline transition duration-300" onClick={() => setIsOpen(false)}>FAQ</Link></li>
            <li><Link to="/contacto" className="block text-gray-600 hover:text-blue-600 hover:underline transition duration-300" onClick={() => setIsOpen(false)}>Contacto</Link></li>
            <li><button className="bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition duration-300 w-full" onClick={() => setIsOpen(false)}>Contacto</button></li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
